import type { AxiosInstance } from 'axios';
import axios from 'axios';
import { createContext, useContext } from 'react';

const AxiosInstanceContext = createContext<AxiosInstance>(axios);

export function useAxiosInstance() {
  return useContext(AxiosInstanceContext);
}

export const AxiosInstanceProvider = AxiosInstanceContext.Provider;
const AxiosInstanceConsumer = AxiosInstanceContext.Consumer;
